import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { clearAuthData, selectUserInformations, setAuthData } from "../features/authSlice";
import axios from "axios";
import { API } from "../shared/api/Api";
import Toast from "../components/Sweetalert/Sweetalert";
import { showToast } from "../utils/utils";
import { getAuthCookies, isAuthenticatedViaCookies } from "../utils/cookieUtils";

export const useAuthValidation = () => {
  const [isValid, setIsValid] = useState(false);
  const [loading, setLoading] = useState(true);
  const dispatch = useDispatch();
  const user = useSelector(selectUserInformations);

  useEffect(() => {
    const validateToken = async () => {
      // If no user in Redux state, try to restore from cookies
      if (!user) {
        try {
          const cookieAuthData = getAuthCookies();
          if (cookieAuthData && isAuthenticatedViaCookies()) {
            // Restore authentication data from cookies to Redux
            dispatch(setAuthData(cookieAuthData));
            setIsValid(true);
            setLoading(false);
            return;
          }
        } catch (error) {
          console.error('Error restoring auth from cookies:', error);
        }
        
        setIsValid(false);
        setLoading(false);
        return;
      }

      try {
        const { data } = await axios.get(API.Admin.validateToken, {
          headers: { Authorization: `Bearer ${user.token}` },
        });

        if (data.status === 200 && data.errorCode === 0) {
          setIsValid(true);
        } else {
          data.status === 401 && setIsValid(false);
          dispatch(clearAuthData());
          showToast("Login Required", data.message, "info");
        }
      } catch (error) {
        setIsValid(false);
        // If token validation fails, clear both Redux and cookies
        dispatch(clearAuthData());
      } finally {
        setLoading(false);
      }
    };

    validateToken();
  }, [user, dispatch]);

  return { isValid, loading , user };
};
